import { closest } from '@jotforminc/utils';

import {
  addClass, removeClass, forEach, map, hasClass
} from './utils';
import Slider from './slider';

class Matrix {
  constructor(params) {
    this.init = this.init.bind(this);
    this.handlePopulateData = this.handlePopulateData.bind(this);
    this.selectNextQuestion = params.selectNextQuestion;
    this.isFeedbackEmbedButton = params.isFeedbackEmbedButton;
    this.question = params.question;
    this.sliders = [];
    this.matrixContainer = global.document.querySelector(`#matrix_${this.question.id}`);
    this.dataType = this.matrixContainer.getAttribute('data-type');
    this.init();
  }

  handlePopulateData(event) {
    try {
      const { featureSet, items } = event.detail;
      const useDcols = featureSet.includes('useDcols');

      switch (this.dataType) {
        case 'Slider':
        case 'Emoji Slider':
          forEach(items, (row, i) => {
            let percentage = 0;
            if (useDcols) {
              const filledIndex = row.reduce((prev, curr, currIndex) => {
                if (curr !== '') return currIndex;
                return prev;
              }, -1);
              percentage = (filledIndex / (items.length - 1)) * 100;
            } else {
              const sliderInputs = this.sliders[i].slider.container.querySelectorAll('input[type=radio]');
              forEach(sliderInputs, (el, index) => {
                if (el.value === row) {
                  percentage = (index / (sliderInputs.length - 1)) * 100;
                }
              });
            }
            this.sliders[i].slider.setRange(percentage);
            this.sliders[i].slider.props.onChange({ value: percentage });
          });
          break;
        default:
      }
    } catch (err) {
      console.error('Error while populating matrix data', { event });
    }
  }

  init() {
    this.matrixContainer.addEventListener('populateData', this.handlePopulateData);
    const { dataType, matrixContainer, question } = this;
    switch (dataType) {
      case 'Slider':
      case 'Emoji Slider':
        this.handleSliders(matrixContainer);
        break;
      case 'Yes No':
        this.handleToggles(question, matrixContainer);
        break;
      default:
        break;
    }
  }

  handleToggles(question, matrixContainer) {
    forEach(matrixContainer.querySelectorAll('.forMobile .jfMatrix-choiceWrapper'), el => {
      this.initMobileYesNoButtons(matrixContainer, el);
    });
    // forEach(matrixContainer.querySelectorAll('.jfYesno.forMatrix.form-matrix-values'), (el) => {
    //   el.addEventListener('keypress', (e) => {
    //     if (e.keyCode === 32) {
    //       e.target.click();
    //     }
    //   });
    //   el.addEventListener('click', (e) => {
    //     e.target.closest('.js-matrixRow').querySelectorAll('.jfYesno.forMatrix.form-matrix-values').forEach(yesno => yesno.setAttribute('aria-checked', 'false'));
    //     e.target.setAttribute('aria-checked', 'true');
    //   });
    // });
  }

  handleSliders(matrixContainer) {
    // lets update mobile versions on desktop change
    const onSliderValueChange = (sliderIndex, value) => {
      const slider = this.sliders[sliderIndex];
      const rowCount = this.sliders.length / 2;
      const { isDesktopSlider } = slider;
      const equalSliderIndex = isDesktopSlider ? (sliderIndex + rowCount) : (sliderIndex - rowCount);
      const equalSlider = this.sliders[equalSliderIndex];
      equalSlider.slider.setRange(value);
      equalSlider.slider.setFilled();
    };
    const scaleItems = matrixContainer.querySelectorAll('.jfMatrixInputList-item');
    forEach(scaleItems, (scaleItem, index) => {
      const closestMatrixParent = closest(scaleItem, '.jfMatrix');
      const isDesktopSlider = hasClass(closestMatrixParent, 'forDesktop');
      const slider = new Slider({
        qid: this?.question?.id,
        container: scaleItem,
        onChange: event => onSliderValueChange(index, event.value)
      });
      const item = {
        isDesktopSlider,
        slider,
        index
      };
      this.sliders.push(item);
    });
    this.initMobileSliderButtons(matrixContainer);
  }

  // TODO :: refactor this shitty function!
  initMobileSliderButtons(matrixContainer) {
    const mobileSlider = matrixContainer.querySelector('.slider');
    const mobileNext = matrixContainer.querySelector('.jfMobileMatrix-nextRow');
    const mobilePrev = matrixContainer.querySelector('.jfMobileMatrix-prevRow');
    const rowList = map(matrixContainer.querySelectorAll('.jfMobileMatrix-row'), q => q);
    const bulletList = map(matrixContainer.querySelectorAll('.jfMobileMatrix-columnDot'), q => q);
    const rowLength = rowList.length;
    let currentRow = matrixContainer.querySelector('.jfMobileMatrix-row.isSelected');
    let currIndex = rowList.findIndex(q => q === currentRow);
    if (currIndex !== -1) {
      if (bulletList[currIndex]) {
        addClass(bulletList[currIndex], 'isActive');
        bulletList[currIndex].removeAttribute('aria-hidden');
      }
    }

    const mobileItems = map(mobileSlider.querySelectorAll('.jfMatrixInputList-item'), q => q);

    mobileNext.addEventListener('click', () => {
      const newIndex = currIndex + 1;
      if (newIndex !== rowLength) {
        const newEl = rowList[newIndex];
        addClass(newEl, 'isSelected');
        removeClass(currentRow, 'isSelected');
        if (newIndex > 0) {
          mobilePrev.disabled = false;
        }
        if (newIndex + 1 === rowLength) { mobileNext.disabled = true; }

        removeClass(bulletList[currIndex], 'isActive');
        bulletList[currIndex].setAttribute('aria-hidden', 'true');
        addClass(bulletList[newIndex], 'isActive');
        bulletList[newIndex].removeAttribute('aria-hidden');

        removeClass(mobileItems[newIndex], 'isHidden');
        mobileItems[newIndex].removeAttribute('aria-hidden');
        addClass(mobileItems[currIndex], 'isHidden');
        mobileItems[currIndex].setAttribute('aria-hidden', 'true');
        //
        currentRow = newEl;
        currIndex = newIndex;
      }
    });
    mobilePrev.addEventListener('click', () => {
      if (currIndex !== 0) {
        const newIndex = currIndex - 1;
        const newEl = rowList[newIndex];
        addClass(newEl, 'isSelected');
        removeClass(currentRow, 'isSelected');
        if (newIndex === 0) { mobilePrev.disabled = true; }
        if (newIndex >= rowLength) { mobileNext.disabled = true; }
        if (newIndex < rowLength - 1) {
          mobileNext.disabled = false;
        }
        removeClass(mobileItems[newIndex], 'isHidden');
        mobileItems[newIndex].removeAttribute('aria-hidden');
        addClass(mobileItems[currIndex], 'isHidden');
        mobileItems[currIndex].setAttribute('aria-hidden', 'true');

        removeClass(bulletList[currIndex], 'isActive');
        bulletList[currIndex].setAttribute('aria-hidden', 'true');
        addClass(bulletList[newIndex], 'isActive');
        bulletList[newIndex].removeAttribute('aria-hidden');
        //
        currentRow = newEl;
        currIndex = newIndex;
      }
    });
  }

  // refactor this shit
  initMobileYesNoButtons(matrix, element) {
    const yesSelection = element.querySelector('.jsMatrix-mobileYes');
    const noSelection = element.querySelector('.jsMatrix-mobileNo');
    let lastStatus;
    const elementCount = matrix.querySelectorAll('.forMobile .jfMatrix-choiceWrapper').length;
    const changeStatus = status => {
      const activeOrder = parseInt(matrix.querySelector('.forMobile .jfMatrix-choiceWrapper.isActive').getAttribute('data-order'), 10);
      if (status !== lastStatus) {
        lastStatus = status;
        if (activeOrder < elementCount - 1) {
          setTimeout(() => {
            matrix.querySelector('.forMobile .jfMobileMatrix-nextRow.forMatrixNext').click();
          }, 300);
        }

        const isLastElement = activeOrder + 1 === elementCount;
        // Auto-select next question if element selection completed
        if (isLastElement && this.isFeedbackEmbedButton) {
          clearTimeout(this.autoNextTimer);
          this.autoNextTimer = setTimeout(() => {
            this.selectNextQuestion();
          }, 500);
        }
      }
    };
    yesSelection.addEventListener('change', () => { changeStatus(true); });
    noSelection.addEventListener('change', () => { changeStatus(false); });
  }
}

export default Matrix;
